/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_V2_Default_Speed_DescriptionInputs */

const en_settings_v2_default_speed_description = /** @type {(inputs: Settings_V2_Default_Speed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applied when you start a new document`)
};

const es_settings_v2_default_speed_description = /** @type {(inputs: Settings_V2_Default_Speed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se aplica al empezar un documento nuevo`)
};

/**
* | output |
* | --- |
* | "Applied when you start a new document" |
*
* @param {Settings_V2_Default_Speed_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_v2_default_speed_description = /** @type {((inputs?: Settings_V2_Default_Speed_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_V2_Default_Speed_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_v2_default_speed_description(inputs)
	return en_settings_v2_default_speed_description(inputs)
});